module.exports = __webpack_public_path__ + "img/pcb_03@2x.3c1add70.png";